var _path;

import * as React from "react";

function SvgMarkAsRead(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 33a3 3 0 01-3 3H7a3 3 0 01-3-3V16.545a3 3 0 011.15-2.36c1.556-1.221 2.843-2.211 10.262-7.595C16.463 5.823 18.55 3.978 20 4c1.45-.022 3.537 1.823 4.588 2.59 7.418 5.383 8.707 6.374 10.263 7.594A3 3 0 0136 16.545V33zm-4.104-12.288a.5.5 0 00-.709-.119 1028.961 1028.961 0 01-6.599 4.817C23.537 26.177 21.45 28.022 20 28c-1.45.021-3.535-1.822-4.588-2.59a1064.256 1064.256 0 01-6.6-4.817.5.5 0 00-.708.12l-.567.824a.5.5 0 00.115.685c1.43 1.057 3.466 2.543 6.581 4.805C15.502 27.95 17.767 30.015 20 30c2.233.015 4.498-2.048 5.766-2.973 3.116-2.262 5.152-3.748 6.582-4.805a.5.5 0 00.115-.685l-.567-.825z"
  })));
}

export default SvgMarkAsRead;